<template>
   <div class="address" v-loading.fullscreen.lock="loading">
       <headerTab :tabList="tabList" @tabChange="tabChange" :selectTabId="tabId"></headerTab>
       <el-button class="address_btn" type="primary" @click="goAddAddress()">新建地址</el-button>
       <div class="address_box" v-if="total > 0">
           <div class="address_box_content" v-for="(item,index) in addressList" :key="index">
               <div class="address_box_content_top">
                   <div class="address_box_content_top_title" v-if="tabId == 2">
                       <span style="margin-right:10px">{{item.province + item.city + item.district}}</span>
                       <!-- <span>{{item.contacts_phone}}</span> -->
                   </div>
                   <div class="address_box_content_top_title" v-if="tabId == 1">
                       <span style="margin-right:10px">{{item.contacts_name}}</span>
                       <span>{{item.contacts_phone}}</span>
                   </div>
                   <div class="address_box_content_top_action">
                       <div class="address_box_content_top_action_edit" @click="goAddAddress(item.id)">
                           <img src="../../assets/adress/address_edit.png" alt="">
                           <span>编辑</span>
                       </div>
                       <div class="address_box_content_top_action_edit" @click="deleteAddress(item.id)">
                           <img src="../../assets/adress/address_delete.png" alt="">
                           <span>删除</span>
                       </div>
                   </div>
               </div>
               <div class="address_box_content_bottom">
                   <div class="address_box_content_bottom_title">
                       <span>{{item.owner_name}}</span>
                       <span>{{item.province + item.city + item.district + item.detalied_address}}</span>
                   </div>
                   <div  class="address_box_content_bottom_action">
                       <el-radio @change="changeDefault" v-model="radio" :label="item.id">设为默认{{tabId == 1 ? '发货' : '收货'}}地址</el-radio>
                   </div>
               </div>
           </div>
           <div class="address_box_pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :pager-count="9"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>
                <div class="address_box_pagination_right">
                    <div class="address_box_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                    <div class="address_box_pagination_right_input">
                        到第
                        <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                        页
                    </div>
                    <div class="address_box_pagination_right_btn">
                        <el-button size="small" @click="changeNumberInput">确定</el-button>
                    </div>
                </div>
            </div>
       </div>
       <div class="null" v-if="total == 0">
            <img src="../../assets/null.png" class="null_img" alt="">
            <div class="null_title">暂无地址</div>
            <el-button type="primary" size="small" @click="goAddAddress()">新建地址</el-button>
        </div>
       
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
export default {
   data (){
       return {
           tabList:[
               {name:'发货地址',id:1},
               {name:'收货地址',id:2}
           ],
           radio:1,
           addressList:[],
           tabId:1,
           pageNumber:1,
           total:0,
           lastPage:0,
           pageSize:10,
           pageNumberInput:1,
           loading:false
       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       deleteAddress(id){
            this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.$delete('Address/' + id,{})
                    .then(data => {
                        this.loading = false;
                        if(this.addressList.length == 1 && this.pageNumber != 1){
                            this.pageNumber = this.pageNumber - 1;
                            this.pageNumberInput = this.pageNumber;
                        }
                        this.getAddressList();
                        this.$message.success('删除成功');
                    }, error => {
                        this.loading = false;
                        this.$message.error(error);
                    });
            }).catch(() => {
            });
           
       },
       changeDefault(){
           this.loading = true;
           this.$put('setDefaultAddress/' + this.radio,{})
                    .then(data => {
                        this.loading = false;
                        this.$message.success('设置成功！');
                        _.each(this.addressList , item => {
                            if(item.id == this.radio){
                                item.is_default = 1;
                            }else{
                                item.is_default = 0;
                            }
                        });
                    } , error => {
                        this.loading = false;
                        let findIndex = _.findIndex(this.addressList , item => {
                            return item.is_default === 1;
                        });
                        if(findIndex == -1){
                            this.radio = '';
                        }else{
                            this.radio = this.addressList[findIndex].id;
                        }
                        this.$message.error(error);
                    });
           
       },
       tabChange(id){
           this.tabId = id;
           this.total = 0;
           this.pageNumber = 1;
            this.pageNumberInput = 1;
           this.getAddressList();
       },
        //    切换页码
        handleCurrentChange(val){
            this.pageNumber = val;
            this.pageNumberInput = val;
            this.getAddressList();
        },
        // 手动输入页码后确定
        changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return 
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getAddressList();
        },
       getAddressList(type){
           this.addressList = [];
           this.loading = true;
           this.$get('Address',{type:this.tabId,page_index:this.pageNumber,page_size:this.pageSize})
            .then(data => {
                this.addressList = data.data;
                let findIndex = _.findIndex(this.addressList , item => {
                    return item.is_default === 1;
                });
                if(findIndex == -1){
                    this.radio = '';
                }else{
                    this.radio = this.addressList[findIndex].id;
                }
                this.total = data.total;
                this.lastPage = data.last_page;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });;
       },
       goAddAddress(id){
           if(id){
               this.$router.push({path:'/add_address',query:{id:id,type:this.tabId}});
           }else{
               this.$router.push({path:'/add_address',query:{type:this.tabId}});
           }
       }
   },
   created() {
       console.log(this.$route)
       if(this.$route.params && this.$route.params.type == 2){
           this.tabId = 2;
       }
   },
   mounted() {
       this.getAddressList();
   }
}
</script>

<style scoped lang='less'>
.address{
    // padding: 30px 40px 20px 30px;
    position: relative;
    /deep/ .address_btn.el-button{
        position: absolute;
        width:104px;
        top:0;
        right:0;
        font-size: 14px;
    }
    &_box{
        &_content{
            padding: 20px;
            width: 800px;
            margin-left:20px;
            margin-top: 20px;
            background: #F7F9FC;
            &_top{
                display: flex;
                justify-content:space-between;
                align-items: center;
                &_title{
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 18px;
                }
                &_action{
                    display: flex;

                    &_edit{
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        margin-left:20px;
                        img{
                            width:20px;
                        }
                        span{
                            font-size: 16px;
                            color:#A6AEC1;
                        }
                    }
                    

                }
            }
            &_bottom{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top:16px;
                &_title{
                    span{
                        font-size: 14px;
                        color:#666666;
                        margin-right: 10px;
                    }
                }
                &_action{
                    /deep/ .el-radio__label{
                        color:#A6AEC1;
                    }
                    /deep/ .el-radio .el-radio__inner{
                        border-color:#A6AEC1;
                        background: transparent;
                    }
                    /deep/ .el-radio.is-checked .el-radio__inner{
                        background: #409EFF;
                        border-color: #DCDFE6;
                    }
                }
            }
        }

    &_pagination{
        padding-top:30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#000000;
        /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
            min-width: 36px;
            height: 36px;
            padding-top:4px;
            margin: 0 4px;
        }
        /deep/ .btn-prev{
            margin-left: 0;
        }
        &_right{
            display: flex;
            align-items: baseline;
            &_num{
                span{
                    color:#3D7FFF;
                }
                
            }
            &_input{
                margin:0 10px;
            }
            &_btn{
                /deep/ .el-button{
                    background:#F0F2F5;
                    height: 36px;
                    border:1px solid #D7DBE0;
                    font-size: 14px;
                    color:#333;
                }
                /deep/ .el-button:hover{
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }
                
            }
        }
    }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/address/address.vue